<template>
  <main class="vote-page">
            <header class="vote-page__nav">
              <button type="button" :aria-label="$t('frontend.common.back')" @click="back"><van-icon name="arrow-left" /></button>
            </header>
            <section class="vote-status">
              <div class="vote-status__title">
                <strong>{{ $t('reservation.voting_in_progress') }}</strong>
                <button type="button" :aria-label="$t('reservation.switch_activity')" @click="showRight"><van-icon name="bars" /></button>
              </div>
              <b>{{ displayPeriod }}</b>
              <span class="vote-status__timer"><van-count-down :key="lottery.now_expect" :time="time" format="mm:ss" @finish="check" /></span>
              <div class="vote-status__footer"><span>{{ $t('reservation.voting_activity') }}</span><button type="button" @click="active = !active">{{ $t('reservation.history') }} <van-icon name="arrow-down" /></button></div>
            </section>

            <section class="vote-options">
              <h1>{{ $t('reservation.voting_options') }}</h1>
              <div class="vote-options__grid">
                <button v-for="item in voteOptions" :key="item.type" type="button" :disabled="submitting" :class="{ 'is-selected': choose[item.type] }" @click="choosePlay(item.type, item.name)">
                  <img :src="item.icon" :alt="item.label"><b>{{ item.label }}</b>
                </button>
              </div>
            </section>

            <section class="vote-feed">
              <h2>{{ $t('reservation.watch_live_vote') }}</h2>
              <div class="vote-feed__viewport">
                <div class="vote-feed__track">
                  <p v-for="(item, index) in liveFeed.concat(liveFeed)" :key="index">{{ item }}</p>
                </div>
              </div>
            </section>

            <section v-if="formData.length" class="vote-order-panel">
              <strong>{{ $t('reservation.choose_vote', { count: formData.length, points: totalVotePoints }) }}</strong>
              <label>
                <span>{{ $t('reservation.dot') }}:</span>
                <input v-model="money" type="number" min="1" inputmode="numeric" :disabled="submitting" :placeholder="$t('reservation.dot')">
                <button type="button" :disabled="submitting" @click="allClear">{{ $t('reservation.rewind') }}</button>
              </label>
              <button class="vote-order-panel__submit" type="button" :disabled="submitting" @click="doSub">{{ submitting ? $t('common.loading') : $t('reservation.vote') }}</button>
              <p v-if="submitError" class="vote-order-panel__error" role="alert">{{ submitError }} <router-link v-if="submitUncertain" to="/VoteRecord">{{ $t('reservation.vote_record') }}</router-link></p>
            </section>

            <van-popup v-model="active" position="top" class="vote-history-popup">
              <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <div class="vote-history">
                  <header class="vote-history__header">
                    <span>{{ $t('reservation.period') }}</span>
                    <span>{{ $t('reservation.open_reward_results') }}</span>
                  </header>
                  <div v-for="(item, index) in lottery_list" :key="item.id || index" class="vote-history__row">
                    <span>{{ formatPeriod(item.expect) }}</span>
                    <div><b v-for="(result, resultIndex) in historyResults(item)" :key="resultIndex">{{ result }}</b></div>
                  </div>
                </div>
              </van-pull-refresh>
            </van-popup>
    <van-popup v-model="showModel" position="right" :style="{ width: '70%',height:'100%' }">
       <div class="list">
        
          <div class="item" v-for="(i,index) in gameitemData" :key="index" @click="tabList(i.id,i.key)">
              <div>{{ $t('reservation.linked_activity') }}</div>
              <div style="margin: 15px 0 0 15px;">
                <div style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;">
                  <van-image
  width="60"
  height="61"
  :src="i.ico"
  style=""
/>
                </div>
  
<div style="font-size: 15.12px;">{{ formatLotteryName(i.name) }}</div>
              </div>
            </div>
       
          
       </div>
      </van-popup>
  </main>
</template>

<script>
import voteRoseIcon from "../../assets/img/1.gif";
import voteShipIcon from "../../assets/img/2.gif";
import voteHeartIcon from "../../assets/img/3.gif";
import voteRocketIcon from "../../assets/img/4.gif";

export default {
  data() {
    return {
      hasPreviousRoute: false,
      jiesuanpage: false,
      showModel: false,
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: [],
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: null,
      time: 0,
      refreshTimer: null,
      refreshing: false,
      requestVersion: 0,
      disposed: false,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      submitting: false,
      submitError: "",
      submitUncertain: false,
      ids: this.$route.query.id || '10',
      keys: this.$route.query.key || 'game1',
      gameitemData: [],
    };
  },
  methods: {
    formatPeriod(expect) {
      return String(expect == null ? '' : expect);
    },
    formatLotteryName(name) {
      return String(name || '').replace(/^(啟動數據|啟用數據|启动数据|启用数据)/, this.$t('reservation.activity_title'));
    },
    historyResults(item) {
      const values = Array.isArray(item.opencode) ? item.opencode : String(item.opencode || '').split(/[,|]/);
      const dice = values.map(Number).filter(value => Number.isFinite(value));
      if (dice.length >= 3) {
        const sum = dice.reduce((total, value) => total + value, 0);
        return [
          sum >= 11 ? this.$t('reservation.vote_rose') : this.$t('reservation.vote_ship'),
          sum % 2 ? this.$t('reservation.vote_heart') : this.$t('reservation.vote_rocket')
        ];
      }
      const labels = { big: 'vote_rose', small: 'vote_ship', one: 'vote_heart', two: 'vote_rocket' };
      return values.slice(0, 2).map(value => this.$t(`reservation.${labels[String(value).trim()] || 'vote_rocket'}`));
    },
    maskedVoteName(item, index) {
      const raw = String(item.username || item.user_name || item.name || item.expect || index + 1);
      const compact = raw.replace(/\s+/g, '');
      return compact.length >= 4 ? `${compact.slice(0, 2)}****${compact.slice(-2)}` : `U${String(index + 1).padStart(2, '0')}****`;
    },
    voteOrdinal(index) {
      return this.$t(`reservation.vote_ordinal_${(index % 5) + 1}`);
    },
    back() {
      if (this.hasPreviousRoute) return this.$router.back();
      return this.$router.replace('/Game');
    },
    async doSub() {
      if (this.submitting) return false;
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }
      if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      const amount = Number(this.money);
      if (!Number.isFinite(amount) || amount <= 0) {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      const balance = Number(this.userInfo.money);
      if (!this.userInfo.id || !this.lottery.id || !Number.isFinite(balance)) {
        this.$toast(this.$t("reservation.order_not_ready"));
        return false;
      }
      if (balance - amount * this.formData.length < 0) {
        this.$toast(this.$t("reservation.balance_enough"));
        return false;
      }
      this.submitting = true;
      this.submitError = "";
      this.submitUncertain = false;
      let res;
      try {
        res = await this.$http({
          method: "post",
          data: {
            item: this.gameitem,
            money: this.money,
            lid: this.lottery.id,
            mid: this.userInfo.id,
            expect: this.lottery.now_expect,
          },
          url: "game_place_order",
        });
      } catch (error) {
        // A failed response does not prove the server rejected the order.
        res = { code: 0 };
      } finally {
        this.submitting = false;
      }
      if (res && Number(res.code) === 200) {
        this.$toast(res.msg);
        this.allClear();
        this.getUserInfo();
        return true;
      }
      this.submitUncertain = !res || !Number.isFinite(Number(res.code)) || Number(res.code) === 0;
      this.submitError = this.submitUncertain
        ? this.$t("reservation.order_result_unknown")
        : res.msg || this.$t("common.request_failed");
      this.$toast(this.submitError);
      return false;
    },
    allClear() {
      if (this.submitting) return;
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.submitError = "";
      this.submitUncertain = false;
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.$router.push('/VoteRecord');
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {
      if (this.submitting) return;
      
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      if (this.submitting) return;
      console.log(type, name);
      console.log(this.choose)
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }
      if (this.formData.length >= 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
        console.log(this.shopchoose, 'ssss')
      
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        window.clearTimeout(this.refreshTimer);
        this.$router.push({ path: "/Login" });
      } else {
        return this.refreshLottery();
      }
    },
    async refreshLottery() {
      if (this.refreshing || this.disposed) return;
      window.clearTimeout(this.refreshTimer);
      const version = this.requestVersion;
      this.refreshing = true;
      let delay = 3000;
      try {
        const [ready] = await Promise.all([
          this.getLotteryInfo(), this.getLotteryList(), this.getUserInfo()
        ].map(request => request.catch(() => false)));
        if (ready === null) delay = null;
        else if (ready) delay = Math.max(1000, this.time);
      } catch (error) {
        // Keep retrying when a transient request fails.
      } finally {
        if (!this.disposed && version === this.requestVersion) {
          this.refreshing = false;
          // A scheduled draw may arrive several seconds after the countdown ends.
          if (delay !== null) this.refreshTimer = window.setTimeout(() => this.check(), delay);
        }
      }
    },
    async onRefresh() {
      try {
        await this.getLotteryList();
      } finally {
        if (!this.disposed) this.isLoading = false;
      }
    },
    getUserInfo() {
      const version = this.requestVersion;
      return this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (this.disposed || version !== this.requestVersion) return;
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      const version = this.requestVersion;
      return this.$http({
        method: "get",
        data: { id:this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (this.disposed || version !== this.requestVersion) return;
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          console.log("lottery_peilv_list:",this.lottery_peilv_list);

        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      const version = this.requestVersion;
      return this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (this.disposed || version !== this.requestVersion) return;
        if (res.code === 200) {
          this.lottery_list = Array.isArray(res.data) ? res.data : [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem(){
      return this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        if (this.disposed) return;
        this.gameitemData = res.data;
        console.log(this.gameitemData,'gameitemData')
      })
    },
    tabList(id,key) {
      this.showModel = false
      if (String(id) === String(this.ids) && String(key) === String(this.keys)) return;
      return this.$router.push({ path: '/Lottery', query: { id, key } });
    },
    loadLottery() {
      window.clearTimeout(this.refreshTimer);
      this.requestVersion += 1;
      this.refreshing = false;
      this.ids = this.$route.query.id || '10';
      this.keys = this.$route.query.key || 'game1';
      this.lottery = {};
      this.lottery_list = [];
      this.lottery_peilv_list = {};
      this.sum = null;
      this.time = 0;
      this.allClear();
      this.getLotteryPeilv();
      return this.check();
    },
    getLotteryInfo() {
      const version = this.requestVersion;
      return this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        if (this.disposed || version !== this.requestVersion) return false;
        if (res.code === 200 && res.data) {
          if (
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return null;
          }
          this.lottery = res.data;
          const second = Number(res.data.second);
          this.time = Number.isFinite(second) ? Math.max(0, second * 1000) : 0;
          const opencode = Array.isArray(res.data.opencode) ? res.data.opencode.map(Number) : [];
          const hasResult = opencode.length === 3 && opencode.every(value => Number.isInteger(value) && value >= 1 && value <= 6);
          this.sum = hasResult ? opencode.reduce((total, value) => total + value, 0) : null;
          return hasResult && this.time > 0;
        } else if (res.code === 401) {
          this.$toast(res.msg);
          return null;
        }
        return false;
      }).catch(() => false);
    },
  },
  watch: {
    '$route.query'() {
      if (this.$route.path !== '/Lottery') return;
      if (String(this.$route.query.id || '10') !== String(this.ids) ||
          String(this.$route.query.key || 'game1') !== String(this.keys)) this.loadLottery();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => { vm.hasPreviousRoute = Boolean(from.name); });
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getGameItem()
      this.loadLottery();
    }
  },
  computed: {
    lotteryTitle() { return this.formatLotteryName(this.lottery.name); },
    displayPeriod() { return this.formatPeriod(this.lottery.now_expect); },
    voteOptions() {
      const choices = [
        { type: 'big', name: 'big', icon: voteRoseIcon, label: this.$t('reservation.vote_rose') },
        { type: 'small', name: 'small', icon: voteShipIcon, label: this.$t('reservation.vote_ship') },
        { type: 'one', name: 'one', icon: voteHeartIcon, label: this.$t('reservation.vote_heart') },
        { type: 'two', name: 'two', icon: voteRocketIcon, label: this.$t('reservation.vote_rocket') }
      ];
      return choices;
    },
    liveFeed() {
      const records = this.lottery_list.slice(0, 4);
      if (records.length) {
        return records.map((record, index) => this.$t('reservation.live_vote_message', {
          name: this.maskedVoteName(record, index),
          ordinal: this.voteOrdinal(index)
        }));
      }
      return [0, 1, 2, 3].map(index => this.$t('reservation.live_vote_message', { name: this.maskedVoteName({}, index), ordinal: this.voteOrdinal(index) }));
    },
    totalVotePoints() {
      const points = Number(this.money || 0);
      return Number.isFinite(points) && points > 0 ? points * this.formData.length : 0;
    },
    rose() { return this.$t('reservation.rose'); },
    lily() { return this.$t('reservation.lily'); },
    balloon() { return this.$t('reservation.balloon'); },
    fireworks() { return this.$t('reservation.fireworks'); },
    size() {
      if (this.sum >= 11 && this.sum <= 18) return this.rose;
      if (this.sum >= 3 && this.sum <= 10) return this.lily;
      return '';
    },
    double() {
      if (this.sum < 3 || this.sum > 18 || !Number.isFinite(this.sum)) return '';
      return this.sum % 2 === 0 ? this.balloon : this.fireworks;
    },
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };
   
      if (!this.formData.length) return this.$t('reservation.no_choose');
      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    }
  },
  beforeDestroy() {
    this.disposed = true;
    this.requestVersion += 1;
    window.clearTimeout(this.refreshTimer);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.lottery-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--lottery-unit) * 6);
  height: calc(var(--lottery-unit) * 8);
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.nav-bar .right {
  padding-left: calc(var(--lottery-unit) * 1.06667);
  padding-right: calc(var(--lottery-unit) * 1.06667);
  color: #fff;
  font-size: calc(var(--lottery-unit) * 3.312);
  border-radius: calc(var(--lottery-unit) * 1.33333);
 
  line-height: calc(var(--lottery-unit) * 8);
}
.lottery {
  background: url("/img/lotterybg.png") no-repeat
    top;
  background-size: contain;
  min-height: 100vh;
  height: 100dvh;
  background-color: #fff;
  color: #000;
}
.lottery .van-nav-bar {
  background: linear-gradient(
    90deg,
    rgba(223, 53, 173, 0.8),
    rgba(79, 29, 181, 0.8)
  ) !important;
}
.record {
  padding-left: calc(var(--lottery-unit) * 2.66667);
  padding-right: calc(var(--lottery-unit) * 2.66667);
  background: linear-gradient(
    90deg,
    rgba(223, 53, 173, 0.8),
    rgba(79, 29, 181, 0.8)
  );
  box-shadow: 0 calc(var(--lottery-unit) * 0.53333) calc(var(--lottery-unit) * 0.53333) 0 #cacaca;
  z-index: 1;
  flex-shrink: 0;
}
.record .period {
  display: flex;
  align-items: center;
  padding: calc(var(--lottery-unit) * 2.66667) 0;
}
.record .period .cover {
  width: calc(var(--lottery-unit) * 13.86667);
  height: calc(var(--lottery-unit) * 13.86667);
  -o-object-fit: cover;
  object-fit: cover;
}
.record .period .period-number {
  flex: 1;
  margin-left: calc(var(--lottery-unit) * 5.33333);
  margin-right: calc(var(--lottery-unit) * 2.66667);
  height: calc(var(--lottery-unit) * 6.66667);
  line-height: calc(var(--lottery-unit) * 6.66667);
  font-size: calc(var(--lottery-unit) * 4.032);
  font-weight: 700;
  color: #fff;
}
.van-count-down {
  color: #f4d70a;
  font-size: calc(var(--lottery-unit) * 6.48);
  margin-top: calc(var(--lottery-unit) * 1.33333);
  float: right;
}
.linear-gradient {
  width: 100%;
  height: calc(var(--lottery-unit) * 0.26667);
  background: transparent;

}
.record .recent {
  display: flex;
  align-items: center;
  height: calc(var(--lottery-unit) * 14.66667);
}
.kuaisan-ball .left {
  justify-content: flex-start;
}
.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: calc(var(--lottery-unit) * 9.33333);
  height: calc(var(--lottery-unit) * 9.33333);
  margin-right: calc(var(--lottery-unit) * 4);
}
.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: calc(var(--lottery-unit) * 5.04);
}
.van-icon {
  font-size: calc(var(--lottery-unit) * 5.33333);
}
.down {
  transition: all 0.5s;
}
.up {
  transform: rotate(180deg);
  transition: all 0.5s;
}
.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.lottery > .wrapper {
  min-height: 0;
}
.options-bar {
  display: flex;
  align-items: center;
  height: calc(100% - calc(var(--lottery-unit) * 13.33333) - env(safe-area-inset-bottom));
  background-color: #fff;
}
.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: calc(var(--lottery-unit) * 13.33333);
  padding: 0 calc(var(--lottery-unit) * 2.66667);
}
.options-bar .game .tips .odds {
  flex: 1;
  font-size: calc(var(--lottery-unit) * 5.04);
  font-weight: 700;
  color: #ff253f;
}
.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}
::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: calc(var(--lottery-unit) * 6.66667);
}
.options-bar .game .tips .play-tip .span-text {
  margin-left: calc(var(--lottery-unit) * 1.33333);
  font-size: calc(var(--lottery-unit) * 5.04);
  font-weight: bolder;
  color: #ff253f;
}
.linear-gradient {
  width: 100%;
  height: calc(var(--lottery-unit) * 0.26667);
}
.sumValueTwoSides {
  display: flex;
  padding: calc(var(--lottery-unit) * 4) 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.rectangle {
  overflow: hidden;
}
.rectangle.large {
  width: calc(50% - calc(var(--lottery-unit) * 7)) !important;
    height: calc(var(--lottery-unit) * 21) !important;
    line-height: calc(var(--lottery-unit) * 21);
    text-align: center;
    background: #fff;
    box-shadow: 0 calc(var(--lottery-unit) * 0.53333) calc(var(--lottery-unit) * 3.2) 0 rgba(0, 0, 0, .1);
    margin: 0 0 calc(var(--lottery-unit) * 4) 4%;
    width: 20%;
    border-radius: calc(var(--lottery-unit) * 2.66667);
}
.rectangle .wrapper {
  position: relative;
  padding: 0 calc(var(--lottery-unit) * 1.33333);
  background: #fff;
}
.rectangle .wrapper .content {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.rectangle.large .wrapper {
  padding-bottom: 100%;
}
.rectangle .wrapper .content .name-text.large {
  font-size: calc(var(--lottery-unit) * 5.76);
}
.rectangle .wrapper .content .name-text {
  color: #ff253f;
 
}
.rectangle .wrapper .content .odd-text.large {
  font-size: calc(var(--lottery-unit) * 3.6);
  margin-top: calc(var(--lottery-unit) * -4);
}
.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}
.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(calc(var(--lottery-unit) * 13.33333) + env(safe-area-inset-bottom));
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: calc(calc(var(--lottery-unit) * 13.33333) + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  box-shadow: 0 0 calc(var(--lottery-unit) * 2.66667) 0 #cacaca;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(var(--lottery-unit) * 13.33333);
  font-size: calc(var(--lottery-unit) * 2.88);
}
.bottom-bar .bar .left .item .text {
  font-size: calc(var(--lottery-unit) * 3.168);
  color: #7d7c7c;
}
.jixuanico {
  font-size: calc(var(--lottery-unit) * 6.48);
}
.bottom-bar .bar .left .line {
  width: calc(var(--lottery-unit) * 0.26667);
  height: calc(var(--lottery-unit) * 6.66667);
  background: #dadada;
}
.bottom-bar .bar .mid {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: right;
}
.bottom-bar .bar .mid .text {
  font-size: calc(var(--lottery-unit) * 4.032);
  font-weight: 700;
  color: #3b3597;
  margin-right: .375rem;
}
.bottom-bar .bar .mid .text.num {
  margin: 0 calc(var(--lottery-unit) * 0.66667);
  color: #ff253f;
}
.bottom-bar .bar .right {
  padding: 0 calc(var(--lottery-unit) * 4);
  margin: 0 calc(var(--lottery-unit) * 4);
  color: #fff;
  background: linear-gradient(20deg, #8673e5, #d958a4);
  font-size: calc(var(--lottery-unit) * 4.032);
  font-weight: 700;
  height: calc(var(--lottery-unit) * 9.33333);
  line-height: calc(var(--lottery-unit) * 9.33333);
  border-radius: calc(var(--lottery-unit) * 2.13333);
  flex-shrink: 0;
  white-space: nowrap;
  cursor: pointer;
}
.rectangle.active .wrapper {
  background-color: #ff253f !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: calc(var(--lottery-unit) * 5.04);
}
::v-deep .van-popup {
  position: absolute;
}
::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}
::v-deep .van-popup--top {
  top: calc(var(--lottery-unit) * -0.13333);
}
.wrapper .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: calc(var(--lottery-unit) * 1.33333) 0;
}
.wrapper .item .left {
  width: 30%;
  font-size: calc(var(--lottery-unit) * 4.32);
  text-align: center;
  font-weight: 700;
  color: #000;
}
.font-weight {
  font-weight: 700 !important;
}
.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: calc(var(--lottery-unit) * 4.32);
  justify-content: center;
  overflow: hidden;
  color: #000;
}
.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}
.wrapper .item .kuaisan-ball {
  margin-left: calc(var(--lottery-unit) * 2.66667);
  flex: 1;
  display: flex;
  align-items: center;
}
.wrapper .item .kuaisan-ball .res-img {
  width: calc(var(--lottery-unit) * 6.66667);
  height: calc(var(--lottery-unit) * 6.66667);
  margin-right: calc(var(--lottery-unit) * 2.66667);
}
.wrapper .item .kuaisan-ball .res-des {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: calc(var(--lottery-unit) * 7);
    line-height: calc(var(--lottery-unit) * 7);
    text-align: center;
    font-size: calc(var(--lottery-unit) * 3.24);
    font-weight: 700;
    margin-right: calc(var(--lottery-unit) * 4);
    width: calc(var(--lottery-unit) * 7);
    border-radius: 50%;
}
.middle{
  border-radius: calc(var(--lottery-unit) * 2.13333);
  padding: 0 calc(var(--lottery-unit) * 2.13333);
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: calc(var(--lottery-unit) * 7);
    line-height: calc(var(--lottery-unit) * 7);
    text-align: center;
    font-size: calc(var(--lottery-unit) * 3.24);
    font-weight: 700;
    margin-right: calc(var(--lottery-unit) * 4);
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: calc(var(--lottery-unit) * 86.66667);
  height: calc(var(--lottery-unit) * 93.33333);
  max-height: 50%;
  z-index: 10;
  border-radius: calc(var(--lottery-unit) * 4);
  overflow: hidden;
  background-color: #fff;
  color: #000;
}
.play-type-tip .title {
  line-height: calc(var(--lottery-unit) * 12);
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  text-align: center;
  color: #fff;
  font-size: calc(var(--lottery-unit) * 5.04);
  font-weight: 700;
}
.mask {
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}
.play-type-tip .wrapper {
  height: calc(100% - calc(var(--lottery-unit) * 1.33333));
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.play-type-tip .wrapper .item {
  padding: calc(var(--lottery-unit) * 5.33333) calc(var(--lottery-unit) * 6.66667);
  display: flex;
  align-items: flex-start;
}
.play-type-tip .wrapper .item .van-icon {
  color: #e6c3a1;
  font-size: calc(var(--lottery-unit) * 8);
}
.play-type-tip .wrapper .item .content .content-title {
  margin-top: calc(var(--lottery-unit) * 2.93333);
  font-size: calc(var(--lottery-unit) * 5.04);
  font-weight: 700;
  color: #000;
  line-height: 0;
}
.play-type-tip .wrapper .item .content .content-detail {
  margin-top: calc(var(--lottery-unit) * 0.66667);
  font-size: calc(var(--lottery-unit) * 3.168);
  color: #000;
  line-height: calc(var(--lottery-unit) * 4);
}
.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: calc(var(--lottery-unit) * 4);
}
.rectangle.active .wrapper {
  background-color: #d07ac7 !important;
}
.rectangle.active .wrapper .name-text,
.rectangle.active .wrapper .odd-text {
  color: #fff !important;
}
.bottom-bar .wrapper {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  padding: calc(var(--lottery-unit) * 2.66667) calc(var(--lottery-unit) * 2.66667) calc(var(--lottery-unit) * 1.33333) calc(var(--lottery-unit) * 2.66667);
  height: auto;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 calc(var(--lottery-unit) * 1.33333) 0 #cacaca;
  transition: transform 0.3s cubic-bezier(0.21, 1.02, 0.55, 1.01);
}
.bottom-bar .wrapper.active {
  transform: none;
}
.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: calc(var(--lottery-unit) * 8.66667);
}
.bottom-bar .wrapper .item .label {
  font-size: calc(var(--lottery-unit) * 3.6);
  line-height: calc(var(--lottery-unit) * 3.33333);
  color: #3b3597;
}
.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  margin: 0 calc(var(--lottery-unit) * 2.13333);
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ed37ae;
  font-size: calc(var(--lottery-unit) * 3.6);
  font-weight: 700;
  height: calc(var(--lottery-unit) * 5.33333);
  line-height: calc(var(--lottery-unit) * 5.33333);
}
.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.van-cell {
  font-size: calc(var(--lottery-unit) * 4.32);
  line-height: calc(var(--lottery-unit) * 6.66667);
}
.bottom-bar .wrapper .item .part {
  margin-right: calc(var(--lottery-unit) * 2.66667);
}
.bottom-bar .wrapper .item .part span {
  font-size: calc(var(--lottery-unit) * 4.32);
  vertical-align: center;
  color: #000;
}
.bottom-bar .wrapper .item .part .number {
  margin: 0 calc(var(--lottery-unit) * 0.66667);
  color: #ff253f;
  font-weight: 700;
}
::v-deep .van-field__control {
  color: #ff253f;
}
.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 calc(var(--lottery-unit) * 2.66667) calc(var(--lottery-unit) * 4);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: calc(var(--lottery-unit) * 81.33333);
  height: calc(var(--lottery-unit) * 90.66667);
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: calc(var(--lottery-unit) * 4);
}
.confirm-order-modal .head {
  position: relative;
  height: calc(var(--lottery-unit) * 10.66667);
}
.confirm-order-modal .head .text {
  padding: 0 calc(var(--lottery-unit) * 2.66667);
  height: calc(var(--lottery-unit) * 4);
  line-height: calc(var(--lottery-unit) * 1.33333);
  text-align: center;
  font-size: calc(var(--lottery-unit) * 5.04);
  font-weight: 700;
  color: #7e5678;
}
::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: calc(var(--lottery-unit) * 0.26667);
}
.van-popup--center {
  border-radius: calc(var(--lottery-unit) * 4);
}
.confirm-order-modal .list {
  flex: 1;
  padding: 0 calc(var(--lottery-unit) * 1.33333);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: calc(var(--lottery-unit) * 1.33333) 0;
}
.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: calc(var(--lottery-unit) * 5.04);
  font-weight: 700;
  line-height: 0;
  word-wrap: break-word;
  word-break: break-all;
}
.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0;
  font-size: calc(var(--lottery-unit) * 3.6);
  color: #979799;
}
.confirm-order-modal .list .lise-item {
  color: #ff253f;
}
.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: calc(var(--lottery-unit) * 4);
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: calc(var(--lottery-unit) * 10.66667);
  text-align: center;
  box-sizing: border-box;
  border-radius: calc(var(--lottery-unit) * 6.66667);
  font-size: calc(var(--lottery-unit) * 5.04);
  font-weight: 700;
}
.confirm-order-modal .sub-bar .item.cancel-btn {
  border: calc(var(--lottery-unit) * 0.26667) solid #979799;
  color: #979799;
  background-color: #fff;
}
.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border: 0;
}
.next-number span {
  font-size: calc(var(--lottery-unit) * 5.04);
  font-weight: 700;
  color: #000;
  float: right;
}
.numberBox .resBox{
  display: flex;
    align-items: center;
    background: #fff;
    border-radius: calc(var(--lottery-unit) * 2.13333);
    padding: calc(var(--lottery-unit) * 2.13333);
    height: 100%;
    margin-left: calc(var(--lottery-unit) * 1.33333);
    width: calc(100% - calc(var(--lottery-unit) * 37));
    box-sizing: border-box;
}
.numberBox {
  display: flex;
  align-items: center;
  padding: .75rem;
  margin-bottom: .625rem;
  border-radius: .5rem;
  background: rgb(244, 124, 213);
}
.result-heading {
  flex-shrink: 0;
  border-right: .25rem solid rgb(249, 177, 231);
  padding: 0 1.875rem 0 .625rem;
  color: #fff;
  font-size: 1.08rem;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}
.resBox .resItem,
.resBox .result-tag {
  width: calc(var(--lottery-unit) * 9);
    height: calc(var(--lottery-unit) * 9);
    line-height: calc(var(--lottery-unit) * 9);
    margin-right: calc(var(--lottery-unit) * 2.66667);
    background: linear-gradient(90deg, #8b73e6, #d75db4);
    border-radius: 50%;
    color: #fff;
    text-align: center;
    flex-shrink: 0;
    font-size: 1.08rem;
    font-weight: 700;
}
.resBox .result-tag:last-of-type { margin-right: 0; }
.result-history {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: auto;
  padding: 0;
  border: 0;
  color: #000;
  background: transparent;
}
.ressquareBox{
  border-radius: calc(var(--lottery-unit) * 2.13333);
  padding: 0 calc(var(--lottery-unit) * 2.13333);
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: calc(var(--lottery-unit) * 7);
    line-height: calc(var(--lottery-unit) * 7);
    text-align: center;
    font-size: calc(var(--lottery-unit) * 3.24);
    font-weight: 700;
}
.ballBox{
  color: #d75db4;
    font-weight: 700;
    margin-right: calc(var(--lottery-unit) * 1.06667);
    font-size: calc(var(--lottery-unit) * 5.4);
}
.list{
 padding: calc(var(--lottery-unit) * 4);
}
.list .item{
  background-color: #e4e4e7;
  border-radius: calc(var(--lottery-unit) * 2.13333);
  padding: calc(var(--lottery-unit) * 5.33333);
  margin-bottom: calc(var(--lottery-unit) * 2.66667);
}

/* Keep the 750-wide design relative to the centered page on larger screens. */
.lottery,
.confirm-order-modal { --lottery-unit: 1vw; }
.lottery .nav-bar,
.lottery ::v-deep .van-nav-bar__content { height: calc(var(--lottery-unit) * 13.33333); }
.lottery ::v-deep .van-nav-bar__title { font-size: calc(var(--lottery-unit) * 5.04); }
.lottery ::v-deep .van-nav-bar__left,
.lottery ::v-deep .van-nav-bar__right { padding: 0 calc(var(--lottery-unit) * 2.13333); }
.lottery ::v-deep .van-nav-bar .van-icon { font-size: calc(var(--lottery-unit) * 6); }
.lottery--long-labels .result-heading {
  padding: 0 calc(var(--lottery-unit) * 2);
  font-size: calc(var(--lottery-unit) * 3.888);
}
.lottery--long-labels .numberBox .resBox { width: auto; flex: 1; min-width: 0; }
.lottery--long-labels .result-tag {
  width: auto;
  min-width: calc(var(--lottery-unit) * 9);
  padding: 0 calc(var(--lottery-unit) * 1);
  border-radius: calc(var(--lottery-unit) * 9);
  font-size: calc(var(--lottery-unit) * 3.024);
}
.lottery--long-labels .resBox .resItem,
.lottery--long-labels .resBox .result-tag { margin-right: calc(var(--lottery-unit) * 1); }
.lottery--long-labels .resBox .result-tag:last-of-type { margin-right: 0; }
@media (min-width: 751px) {
  .lottery,
  .confirm-order-modal { --lottery-unit: .3rem; }
}

.vote-page {
  min-height: 100vh;
  padding: 0.55rem 0.65rem calc(4.35rem + env(safe-area-inset-bottom));
  background: #fff;
  color: #282238;
}

.vote-page__nav {
  height: 3.3rem;
  display: flex;
  align-items: center;
}

.vote-page__nav button {
  width: 1.7rem;
  height: 1.7rem;
  padding: 0;
  border: 0;
  color: #3e3549;
  background: transparent;
}

.vote-page .van-icon { font-size: 1.02rem; }

.vote-status {
  min-height: 8.05rem;
  padding: 0.84rem 0.95rem 0.72rem;
  border-radius: 0.92rem;
  color: #fff;
  background: linear-gradient(110deg, #8547bd 0%, #b594d8 100%);
  box-shadow: 0 0.32rem 0.72rem rgba(100, 57, 143, 0.25);
}

.vote-status__title,
.vote-status__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vote-status__title strong,
.vote-status b {
  display: block;
  color: #fff;
  font-size: 0.87rem;
  font-weight: 700;
}

.vote-status__title button,
.vote-status__footer button {
  padding: 0;
  border: 0;
  color: #fff;
  background: transparent;
  font-size: 0.76rem;
}

.vote-status__title .van-icon { font-size: 1.18rem; }
.vote-status b { margin-top: 0.14rem; }

.vote-status__timer {
  display: inline-flex;
  align-items: center;
  height: 1.2rem;
  margin-top: 0.65rem;
  padding: 0 0.4rem;
  border: 0.05rem solid rgba(255, 255, 255, 0.7);
  border-radius: 0.32rem;
}

.vote-status__timer .van-count-down {
  margin: 0;
  float: none;
  color: #fff;
  font-size: 0.74rem;
  font-weight: 700;
}

.vote-status__footer { margin-top: 0.58rem; font-size: 0.75rem; }
.vote-status__footer button .van-icon { vertical-align: -0.08rem; }

.vote-options { margin-top: 0.88rem; }
.vote-options h1 {
  position: relative;
  top: 0.25rem;
  margin: 0 0 0.53rem;
  padding-left: 0.62rem;
  color: #29213a;
  font-size: 0.96rem;
  font-weight: 700;
}
.vote-options h1::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.13rem;
  width: 0.2rem;
  height: 1rem;
  border-radius: 999px;
  background: #914bc0;
}

.vote-options__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.68rem;
}

.vote-options__grid button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  min-height: 4.94rem;
  border: 0.05rem solid #f1edf5;
  border-radius: 0.72rem;
  color: #1d1827;
  background: #fff;
  box-shadow: 0 0.2rem 0.52rem rgba(42, 31, 54, 0.1);
  font-size: 1rem;
}

.vote-options__grid button img {
  width: 2.125rem;
  height: 2.125rem;
  object-fit: contain;
}
.vote-options__grid button b { font-weight: 700; }
.vote-options__grid button.is-selected {
  color: #fff;
  border-color: #7b3fb4;
  background: linear-gradient(145deg, #8848bc, #713aac);
  box-shadow: 0 0.18rem 0.45rem rgba(111, 57, 175, 0.27);
}

.vote-feed {
  margin-top: 0.95rem;
  overflow: hidden;
  border: 0.05rem solid #eae5ef;
  border-radius: 0.42rem;
  text-align: center;
}

.vote-feed h2 {
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: #fff;
  background: linear-gradient(100deg, #8d4fbd, #b999d8);
  font-size: 0.87rem;
  font-weight: 700;
}

.vote-feed__viewport {
  height: 6.58rem;
  overflow: hidden;
}

.vote-feed__track {
  animation: voteFeedScroll 12s linear infinite;
}

.vote-feed p {
  margin: 0;
  padding: 0.48rem 0.35rem;
  color: #6c6572;
  border-bottom: 0.05rem solid #eeeaf0;
  font-size: 0.74rem;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vote-feed p:last-child { border-bottom: 0; }

.vote-order-panel {
  position: fixed;
  z-index: 20;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 14rem;
  padding: 5.5rem 0.8rem 0.8rem;
  border-radius: 0.85rem 0.85rem 0 0;
  background: #fff;
  box-shadow: 0 -0.25rem 1rem rgba(44, 31, 58, 0.16);
}

.vote-order-panel > strong {
  position: absolute;
  left: 0.8rem;
  top: 3.68rem;
  color: #7f3eb2;
  font-size: 0.92rem;
}

.vote-order-panel label {
  display: grid;
  grid-template-columns: 1.875rem minmax(0, 1fr) 4.75rem;
  align-items: center;
  gap: 0.5rem;
  color: #7739ad;
  font-size: 0.82rem;
  font-weight: 700;
}

.vote-order-panel input {
  width: 100%;
  height: 2.125rem;
  padding: 0 0.65rem;
  border: 0;
  border-radius: 999px;
  outline: 0;
  color: #51435d;
  background: #eeeef1;
  font-size: 0.78rem;
}

.vote-order-panel label button {
  height: 2.125rem;
  padding: 0;
  border: 0;
  border-radius: 999px;
  color: #897e93;
  background: #eeeef1;
  font-size: 0.75rem;
}

.vote-order-panel__submit {
  width: 100%;
  height: 2.68rem;
  margin-top: 0.81rem;
  border: 0;
  border-radius: 999px;
  color: #fff;
  background: linear-gradient(100deg, #8042bb, #a66ece);
  font-size: 0.9rem;
  font-weight: 700;
}

.vote-page button:disabled,
.vote-order-panel input:disabled {
  opacity: 0.6;
  cursor: wait;
}

.vote-order-panel__error {
  margin: 0.65rem 0 0;
  color: #ac3e50;
  font-size: 0.75rem;
  line-height: 1.5;
}

.vote-order-panel__error a {
  color: #7739ad;
  text-decoration: underline;
}

@keyframes voteFeedScroll {
  from { transform: translateY(0); }
  to { transform: translateY(-50%); }
}

@media (prefers-reduced-motion: reduce) {
  .vote-feed__track { animation: none; }
}

.vote-history-popup {
  top: 11.9375rem !important;
  bottom: 0 !important;
  height: auto !important;
  padding: 0.3125rem 0.6875rem 0;
  background: #fff;
}
.vote-history { color: #2d2437; font-size: 0.77rem; }
.vote-history__header,
.vote-history__row {
  display: grid;
  grid-template-columns: 30% 70%;
  align-items: center;
  min-height: 2.6rem;
  border-bottom: 0.05rem solid #f0edf2;
}
.vote-history__header {
  min-height: 2.25rem;
  color: #16121c;
  font-size: 0.8rem;
  font-weight: 700;
}
.vote-history__header span:first-child,
.vote-history__row > span {
  padding-left: 0.65rem;
  transform: translateY(-0.0625rem);
}
.vote-history__header span:last-child { transform: translateY(-0.0625rem); }
.vote-history__header span:last-child { text-align: center; }
.vote-history__row > div { display: flex; justify-content: center; gap: 0.375rem; }
.vote-history__row b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 1.5rem;
  min-width: 0;
  padding: 0 0.8rem;
  border-radius: 999px;
  color: #fff;
  background: #9b69cc;
  font-size: 0.7rem;
  font-weight: 700;
  text-align: center;
  transform: translateY(0.0625rem);
}

@media (min-width: 751px) {
  .vote-page { width: 30rem; margin: 0 auto; }
}
</style>
